module.exports = __webpack_public_path__ + "img/IMG_4460.860e53d0.jpg";